export default "__VITE_ASSET__DAZUkPSb__"